<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Army Chief Madam Visited Proyash-Chattogram
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        It was an excellent accomplishment by Proyash-Chattogram during the
        visit by the Respected Madam of the Chief of Army Staff of Bangladesh
        Army. <br />
        We are really grateful to her for such compassion towards the children
        with special needs. <br />
        Thanks, Madam, for your positive gesture towards making an inclusive
        society.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
